import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/raw-materials`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/raw-materials`, body, config);
};

export const Put = (payload, config = {}) => {
  const { id } = payload;
  return APIService.put(`/v01/raw-materials/${id}`, {...payload}, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/raw-materials/${id}`, config);
};

export const All = () => {
  return APIService.get(`v01/raw-materials/dropdown`);
}

export const Detail = (id) => {
  return APIService.get(`/v01/raw-materials/${id}`);
}

export const Activation = (id, body, config) => {
  return APIService.post(`/v01/raw-materials-activate/${id}`, body, config);
}

export const Active = (body, config) => {
  return APIService.get(`/v01/active-raw-materials`, body, config);
}

export const Inventories = (rawMaterialId, config) => {
  return APIService.get(`/v01/raw-material-inventories/${rawMaterialId}`, config);
}

export const OrderAvailable = (id, body, config) => {
  return APIService.post(`/v01/raw-material-order-available/${id}`, body, config);
}

export const Export = (params) => {
  return APIService.get('/v01/raw-materials/export', {
    params: {
      keyword: params.keyword || undefined,
    },
  });
};

const RawMaterialService = {
  List,
  Create,
  Put,
  Delt,
  All,
  Detail,
  Activation,
  Active,
  Inventories,
  OrderAvailable,
  Export,
};
export default RawMaterialService;
